import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetUserWalletDetails extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Wallet/GetWalletDetaileList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export { GetUserWalletDetails };
